// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1idzI","question":"Question_question__2wxw0","description":"Question_description__1AYxy"};